// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * Web ToggleButtonGroup Context
 *
 */

import React from 'react'

const ToggleButtonGroupContext = React.createContext({})

export default ToggleButtonGroupContext
